import { useState } from "react";
import { MoveRight, TriangleAlert } from "lucide-react";
import { timeStampToDateAndTime } from "../../../../functions/dateTime/timeStampToDateAndTime.js";
import ReviewCheckpointModal from "../../dialogs/ReviewCheckpointModal.jsx";

const JobCardInformCard = ({ item }) => {
  const [openReview, setOpenReview] = useState(false);
  const { id, status, checkpoint, jobCard, cylinder, checkpointDetails } = item;

  const name = checkpointDetails.name;
  const description = checkpointDetails.description;
  const fullName = checkpoint.updatedBy?.fullName;
  const jobCardStatus = jobCard?.status;
  const stageId = jobCard?.stageId;
  const serialNumber = cylinder?.serialNumber;
  const actualWeight = cylinder?.actualWeight;
  const resultVal = checkpoint.resultVal;
  const lastDispatchVal = checkpoint.lastDispatchValue;
  const isChanged = lastDispatchVal?.toLowerCase() !== resultVal?.toLowerCase();
  const remark = item.remarks;
  const informedToFT = item?.informedToFT;
  const ftName = informedToFT?.fullName;
  const ftPhone = informedToFT?.phoneNumber;
  const ftRemarks = item.ftRemarks;

  const headerFields = [
    { label: "Cylinder", value: serialNumber },
    { label: "Weight", value: `${actualWeight} KG` },
    { label: "Jobcard Stage", value: stageId },
    {
      label: "Jobcard Status",
      value: jobCardStatus === 1 ? "Completed" : "In Progress",
    },
  ];

  return (
    <div className="bg-white rounded-xl shadow-sm border border-stone-200 p-2 md:p-4 md:relative hover:shadow-lg hover:transition">
      {/* ----------------------------- TOP ROW  ----------------------------------------*/}
      <div className="flex flex-wrap gap-3 text-xs text-stone-600 pb-2 border-b-1 mb-2">
        {headerFields.map((field, i) => (
          <span key={i}>
            <strong>{field.label}:</strong> {field.value}
          </span>
        ))}
      </div>
      {/* ---------------------------- CHECKPOINT INFORMATION --------------------------------  */}
      <div className="flex gap-3 items-center">
        <div className="border-r-1 pr-2">
          <h3 className="font-semibold text-stone-800 max-md:text-sm">
            {name}
          </h3>
          <p className="text-xs text-stone-500 pt-1">{description}</p>
        </div>

        <div className="flex items-center gap-2 text-xs flex-wrap">
          {/* Last Dispatch Value */}
          {lastDispatchVal && (
            <span className="px-2 py-0.5 rounded-md bg-gray-100 text-gray-700 border border-gray-200">
              Last Dispatch: {lastDispatchVal.toUpperCase()}
            </span>
          )}

          {/* Arrow */}
          {lastDispatchVal && resultVal && (
            <span className="text-stone-400 font-semibold">
              <MoveRight strokeWidth={0.75} />
            </span>
          )}

          {/* Current Updated Value */}
          {resultVal && (
            <span
              className={`px-2 py-0.5 rounded-md font-medium ${
                lastDispatchVal && resultVal && isChanged
                  ? "bg-red-100 text-red-700"
                  : "bg-blue-100 text-blue-800"
              }`}
            >
              Current: {resultVal.toUpperCase()}
            </span>
          )}
        </div>
      </div>
      {/* ---------------------------- CHECKPOINT UPDATED PERSON DETAILS ------------------------------------- */}
      <div className="text-xs text-stone-500 gap-2 bg-gray-50 border-1 border-gray-100 p-1 md:p-2 inline-flex rounded-md mt-2">
        {" "}
        <p className="border-r-1 pr-2 border-stone-300">
          {" "}
          Informed At: {timeStampToDateAndTime(checkpoint?.updatedAt)}{" "}
        </p>{" "}
        <p>Informed By: {fullName}</p>{" "}
      </div>
      {/* ---------------------------- INFORMED TO (FT) DETAILS ------------------------------------- */}
      {informedToFT && (
        <div className="text-xs text-stone-500 gap-2 bg-gray-50 border border-gray-100 p-1 md:p-2 inline-flex rounded-md mt-2 ml-2">
          <p className="border-r pr-2 border-stone-300">
            Informed To (FT) : {ftName}
          </p>
          <p>Phone: {ftPhone}</p>
        </div>
      )}
      {/* Remarks Info */}
      {remark && (
        <p className="text-xs pt-2 text-gray-600">
          <strong>Remark:</strong> {remark}
        </p>
      )}
      {ftRemarks && (
        <p className="text-xs pt-2 text-gray-600">
          <strong>Remark (FT):</strong> {ftRemarks}
        </p>
      )}

      {/* Show verify message id value changes or mismatch*/}
      {lastDispatchVal && resultVal && isChanged && status === "pending" && (
        <div className="mt-2 px-3 py-2 text-xs rounded-md bg-red-50 border border-red-200 text-red-700 md:w-max flex items-center gap-1">
          <TriangleAlert size={15} /> Change detected from last dispatch. Please
          verify before approval.
        </div>
      )}
      {/* Action  Button*/}
      {status === "pending" && (
        <div
          className={`bg-dark-blue text-white py-[3px] px-3 transition hover:bg-hover-bg rounded-md md:absolute md:right-4 md:bottom-3 max-md:mt-2 w-max cursor-pointer max-md:text-xs`}
          onClick={() => setOpenReview(true)}
        >
          Review
        </div>
      )}
      {openReview && (
        <ReviewCheckpointModal
          reviewId={id}
          name={name}
          description={description}
          setOpenReview={setOpenReview}
        />
      )}
    </div>
  );
};

export default JobCardInformCard;
